import { Component } from '@angular/core';

@Component({
  selector: 'app-blog-190629',
  templateUrl: './blog-190629.component.html'
})
export class Blog190629Component { }
